<template>
  <div class="daka">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="评价">
          <el-select size="small" v-model="searchForm.is_top" clearable placeholder="">
            <el-option label="不限" value=""></el-option>
            <el-option label="精选" value="1"></el-option>
            <el-option label="不是精选" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户id">
          <el-input v-model="searchForm.user_id" placeholder="请输入" clearable style="width:100px"></el-input>
        </el-form-item>
        <el-form-item label="关键字">
          <el-input v-model="searchForm.keyword" clearable placeholder="请输入打卡内容"></el-input>
        </el-form-item>
        <el-form-item label="起始日期">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="searchForm.create_time" type="daterange" clearable value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品评价-->
    <!-- <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus" v-auth="'/product/comment/add'">添加评价</el-button>
    </div> -->
    <!-- <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部评价" name="-1"></el-tab-pane>
        <el-tab-pane :label="'待审核('+num+')'" name="0"></el-tab-pane>
        <el-tab-pane label="审核通过" name="1"></el-tab-pane>
        <el-tab-pane label="审核未通过" name="2"></el-tab-pane>
      </el-tabs>
    </template> -->

    <div class="daka-list f14">
      <div class="item d-s-s d-r border-b p-10-0" v-for="(item, index) in tableData" :key="index">
        <div class="user d-s-c d-c">
          <div class="avatar"><img v-img-url="item.user.avatarUrl" alt="" /></div>
          <p>{{ item.user.nickName }}({{ item.user.user_id }})</p>
          <p class="date gray9">{{ item.date }}</p>
        </div>
        <div class="d-s-s d-c ml20 ww100">
          <div class="f18 d-s-c d-r">
            <!-- <span>编辑</span> -->
            <!-- <div class="ml10"><el-rate v-model="item.comment_score" @change="rateChange(index)"></el-rate></div> -->
            <!-- <span class="ml10">{{item.comment_score}}</span> -->
            <el-tag class="ml10" v-if="item.is_top">精选</el-tag>
          </div>
          <div class="gray9">已打卡{{item.user.study.daka_total}}次 创建于 {{ item.create_time }} 最后更新于{{ item.update_time }}</div>
          <div class="lh24" v-html="item.content"></div>
          <div class="daka-imgs d-s-s mt10" v-if="item.image.length">
            <div class="mr10" v-for="(vv, ii) in item.image" :key="ii">
              <el-image class="img" :src="vv.file_path" fit="cover" :preview-src-list="previewImgs(item.image)" lazy :z-index="ii" style="width:120px; height:120px;border-radius:10px;overflow: hidden;" />
            </div>
          </div>
          <div class="d-b-c d-r ww100 p-10-0">
            <el-link @click="showClick(index)" v-if="show[index]"><i class="el-icon-arrow-up"></i>收起评论({{ item.comment.length }})</el-link>
            <el-link @click="showClick(index)" v-else><i class="el-icon-arrow-down"></i>展开评论({{ item.comment.length }})</el-link>
            <div class="">
              <el-link @click="topClick(index)" :type="item.is_top ? 'primary' : 'info'" size="small" v-auth="'/study/daka/index'">{{ item.is_top ? '取消精选' : '精选'}}</el-link>
              <el-link @click="likeClick(index)" class="ml10" type="info" size="small" v-auth="'/study/daka/index'">{{ item.is_like ? '已赞' : '点赞'}}({{item.like_count}})</el-link>
              <el-link @click="openComment(index)" class="ml10" type="info" size="small" v-auth="'/study/daka/index'">点评</el-link>
            </div>
          </div>
          <div class="comment" :hidden="!show[index]">
            <div class="item d-s-s d-r p-10-0" v-for="(v, i) in item.comment" :key="i">
              <div class="avatar"><img v-img-url="v.user.avatarUrl" alt="" /></div>
              <div class="d-s-s d-c ml10">
                <p>{{ v.user.nickName }}</p>
                <div class="gray9">
                  点评于{{ v.create_time }} 
                  <el-link class="ml10" :type="v.status ? 'primary' : 'info'" @click="commentStatus(index, i)">{{ v.status ? '隐藏' : '可见'}}</el-link>
                  <!-- <el-link class="ml10" @click="commentDel(index, i)">删除</el-link> -->
                  <el-popconfirm title="确定删除该记录吗？" @confirm="commentDel(index, i)">
                    <!-- <el-button slot="reference" size="mini">删除</el-button> -->
                    <el-link class="ml10" type="info" slot="reference">删除</el-link>
                  </el-popconfirm>
                </div>
                <p :class="v.status ? '' : 'gray9'">{{ v.content }}</p>
                <!-- <div class="comment-imgs d-s-s mt10" v-if="v.image.length">
                  <div class="mr10" v-for="(vv, ii) in v.image" :key="ii">
                    <el-image class="img" :src="vv.file_path" fit="cover" :preview-src-list="previewImgs(v.image)" lazy :z-index="ii" style="width:100px; height:100px;border-radius:10px;overflow: hidden;" />
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <div class="d-c-c" style="width:100px">
          <el-link @click="delClick(item)" type="info" v-auth="'/study/daka/index'">删除</el-link>
        </div>
      </div>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
          :page-size="pageSize" layout="total, prev, pager, next, jumper"
          :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>

    <!--添加评价-->
    <Comment v-if="open_comment" :open_comment="open_comment" :selectModel="selectModel" @closeDialog="closeDialogFunc($event, 'comment')"></Comment>

  </div>
</template>

<script>
  import DakaApi from '@/api/study/daka.js';
  import Comment from './part/Comment.vue';

  export default {
    components: {
      Comment,
    },
    data() {
      return {
        rate: null,
        loading: true,
        activeName: '-1',
        num: 0,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*总条数*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索参数*/
        searchForm: {
          user_id: '',
          keyword: '',
          is_top: '',
          create_time: ''
        },
        status: -1,
        /*是否打开添加弹窗*/
        open_comment: false,
        /*当前编辑的对象*/
        categoryModel: {
          catList: [],
          model: {}
        },
        show: [],
        selectModel: {},
      };
    },
    created() {
      // for (let index = 0; index < this.pageSize; index++) {
      //   this.show[index] = true;
      // }
      /*获取列表*/
      this.getData();
    },
    methods: {
      showClick(index){
        this.show[index] = !this.show[index];
        this.$forceUpdate();
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        let Params = self.searchForm;
        self.getData(Params);
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

      /*获取列表*/
      getData(param = '') {
        let self = this;
        let Params = {};
        Params.status = self.status;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        if (param != '') {
          Params.score = param.score;
          Params.name = param.name;
        }
        DakaApi.getList(Params, true).then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total
          self.num = res.data.num;
          for (const key in self.tableData) {
            if (Object.hasOwnProperty.call(self.tableData, key)) {
              self.show[key] = true;
            }
          }
        }).catch(error => {
          self.loading = false;
        });
      },

      /*打开编辑*/
      detailClick(row) {
        this.$router.push({
          path: '/product/comment/Detail',
          query: {
            comment_id: row.comment_id,
          }
        });
      },

      /*订单详情*/
      orderClick(row) {
        this.$router.push({
          path: '/product/comment/Order',
          query: {
            order_id: row.order_id,
          }
        });
      },

      /*删除*/
      delClick(row) {
        let self = this;
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        }).then(() => {
          DakaApi.del({
            daka_id: row.daka_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getData();
          });
        });
      },

      /*评论状态*/
      commentStatus(index, i){
        let self = this;
        let row = self.tableData[index].comment[i];
        console.log(row);
        row.status = !row.status;
        DakaApi.commentStatus({
          comment_id: row.comment_id
        }).then(res => {
          self.$message({
            message: res.msg,
            type: 'success'
          });
        });
      },

      /*删除评论*/
      commentDel(index, i){
        let self = this;
        let row = self.tableData[index].comment[i];
        DakaApi.commentDel({
          comment_id: row.comment_id
        }).then(res => {
          self.tableData[index].comment.splice(i, 1);
          self.$message({
            message: res.msg,
            type: 'success'
          });
        });
      },

      /*精选*/
      topClick(index) {
        let self = this;
        let row = self.tableData[index];
        row.is_top = !row.is_top;
        DakaApi.istop({
          daka_id: row.daka_id
        }).then(res => {
          self.$message({
            message: res.msg,
            type: 'success'
          });
        });
      },

      /*点赞*/
      likeClick(index) {
        let self = this;
        let row = self.tableData[index];
        !row.is_like ? row.like_count++ : row.like_count--;
        row.is_like = !row.is_like;
        DakaApi.like({
          daka_id: row.daka_id
        }).then(res => {
          self.$message({
            message: res.msg,
            type: 'success'
          });
        });
      },

      /*评分*/
      rateChange(index){
        let self = this;
        let row = self.tableData[index];
        DakaApi.rate({
          daka_id: row.daka_id,
          score: row.comment_score
        }).then(res => {
          self.$message({
            message: res.msg,
            type: 'success'
          });
        });
      },

      /*搜索查询*/
      onSubmit() {
        let self = this;
        self.loading = true;
        let Params = self.searchForm;
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        Params.status = self.status;
        DakaApi.getList(Params, true).then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;

          self.totalDataNumber = data.data.list.total
        }).catch(error => {
          self.loading = false;
        });
      },

      /*切换选项卡*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.loading = true;
        self.status = tab.name;
        self.getData();
      },
       /*打开添加*/
      openComment(index) {
        this.selectModel = this.tableData[index];
        this.open_comment = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'comment') {
          this.open_comment = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          if (e.type == 'success') {
            this.getData();
          }
        }
      },

      /*预览图*/
      previewImgs(list){
        let arr = [];
        for (const v of list) {
          arr.push(v.file_path);
        }
        return arr;
      }
    }
  };
</script>

<style lang="scss" scoped>
.daka-list {
  .user {
    width: 80px;
    .avatar img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      overflow: hidden;
    }
    .date {
      margin-top: 5px;
    }
  }
  .comment .avatar img {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/study/daka/index.vue